'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, Divider, Stack, Typography } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { EONLogo } from '@/components/layout/shared/eonLogo';
export const BlankLayout = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      background: "var(--mui-palette-background-pageGradient)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box className="absolute top-0 left-0 flex content-center p-[min(100px,6vw)]"><EONLogo dark={true} /></Box>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Divider orientation="vertical" flexItem={true} variant="middle" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography>{`© ${new Date().getFullYear()} Eon. All rights reserved.`}</Typography>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Stack className="absolute bottom-0 left-0 p-[min(100px,4vw)] gap-[24px]" direction="row" divider={t3}>{t4}<a href="https://www.eon.io/about" target="_blank" rel="noreferrer" className="flex content-center">About Eon<i className="material-symbols-open-in-new w-[20px] h-[20px] ml-[8px]" /></a></Stack>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <Box className="h-full flex flex-col relative" style={t1}>{children}{t2}{t5}</Box>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};